import { Link, Typography } from '@mui/material';
import { FC } from 'react';

const SnackbarMessageWithLink: FC<
  React.PropsWithChildren<SnackbarMessageWithLinkProps>
> = ({ message, linkTitle, linkHref }) => {
  return (
    <Typography>
      {message}
      <Link ml={1} href={linkHref} target='_blank'>
        {linkTitle}
      </Link>
    </Typography>
  );
};

interface SnackbarMessageWithLinkProps {
  message: string;
  linkTitle: string;
  linkHref: string;
}

export default SnackbarMessageWithLink;
